import React from 'react';
import { Button } from '@material-ui/core';
import { Stop as StopIcon } from '@material-ui/icons';
import { useStop } from '../hooks';

const Stop = () => {
  const { handleStop, stopState } = useStop();

  return (
    <Button variant="outlined" disabled={stopState.loading} onClick={handleStop} endIcon={<StopIcon />}>
      Stop
    </Button>
  );
};

export default Stop;
